import * as React from "react";
 
// importing material UI components
import { useState } from 'react';
import WhatsAppMessageTable from './WhatsAppMessageTable';
import Container from '@mui/material/Container';
import {
  Box,
  Grid,
  Typography
} from '@mui/material';
import typography from "../cssUtils/typography";

const WhatsAppMessage = (props) => { 
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 20
  });
  const [lastSynced, setLastSynced] = useState(null);

  return (
    <div className="App">
      {/* <Header WhatsAppMessageState={props.WhatsAppMessageState}/> */}
      <Box  sx={{ px: 0, width: "100%"}}>
        {/* <p>State: {props.WhatsAppMessageState} Time remaining: {props.remaining}</p> */}

        <Grid container alignItems="center" sx={{ mb: 2 }}>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mr: 0, px: 1 }}>
            {lastSynced && (
              <Typography 
                sx={{ ...typography.bodySmall, fontSize: { xs: "12px", md: "14px" }, textAlign: "center" }}
                color="text.secondary"
              >
                Last chat received: {lastSynced} <i>(Logs may take up to 2 minutes to sync)</i>
              </Typography>
            )}
          </Grid>
        </Grid>

        <WhatsAppMessageTable 
          key={props.refreshKey} 
          controller={controller}
          setController={setController}
          lastSynced={lastSynced}
          setLastSynced={setLastSynced}
        />

      </Box>
    </div>
  );
}
export default WhatsAppMessage;
